import { render, staticRenderFns } from "./PlansEditPage.vue?vue&type=template&id=46a90ad6&scoped=true"
import script from "./PlansEditPage.vue?vue&type=script&lang=js"
export * from "./PlansEditPage.vue?vue&type=script&lang=js"
import style0 from "./PlansEditPage.vue?vue&type=style&index=0&id=46a90ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a90ad6",
  null
  
)

export default component.exports